import { Pipe, PipeTransform } from '@angular/core';
import { formatSecondsAsString } from '../format-call-details-seconds/format-detail-seconds.pipe';

@Pipe({
    name: 'waitDuration',
    pure: false,
    standalone: false
})
export class WaitTimeDurationPipe implements PipeTransform {
   transform(startDate: string, endDate: string): string {
      const startSeconds = getSecondsFromStartDate(startDate);
      const endSeconds = endDate ? getSecondsFromStartDate(endDate) : 0;
      return formatSecondsAsString(startSeconds - endSeconds);
   }
}

export function getSecondsFromStartDate(startDate: string): number {
   const currentTime = new Date();
   const startDateObject = new Date(startDate);

   if (isNaN(startDateObject.getTime())) {
      return 0;
   }

   const seconds = Math.floor((currentTime.getTime() - startDateObject.getTime()) / 1000);

   return seconds;
}
